// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Route, Routes } from 'react-router-dom';

import Champion from './pages/champion';
import Home from './pages/home';
import Prize from './pages/prize';
import Verify from './pages/verify';
import BaseContainer from './BaseContainer';

function App() {
  return (
    <Routes>
      <Route element={<BaseContainer />}>
        <Route element={<Prize />} path="/prize" />
        <Route element={<Verify />} path="verify/zk" />
        <Route element={<Champion />} path="verify/champion" />
        <Route element={<Home />} index />
      </Route>
    </Routes>
  );
}

export default App;
